import(/* webpackMode: "eager" */ "/home/runner/work/highrays-yt/highrays-yt/src/app/not-found.tsx");
